export default class BaseNode
{
    constructor(type) 
    {
        this.threeObject = null
        this.edgePosition = null
        this.parentBlockchainIndex = -1
        this.gridCoords = null
        this.type = type
        this.data = null
        this.numberOfDapps = 0
        this.wideViewPosition = null
        this.expandedViewPosition = null
        this.myParsedIndex = null
        this.dappChildIndex = null
        this.htmllabel = null
        this.labelLineObject = null
        this.downLineObject = []
        this.colorA = null
        this.colorB = null
    }
}